import { render, staticRenderFns } from "./MessageCreate.vue?vue&type=template&id=460211d1&"
import script from "./MessageCreate.vue?vue&type=script&lang=js&"
export * from "./MessageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports